<div class="header">
  <div class="title">Generate Document</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>
<form [formGroup]="projectForm">
  <div class="flex flex-col gt-xs:flex-row mt-3">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Select Document</mat-label>
      <mat-select [formControlName]="'file_resource_id'">
        <input
          class="ts-select-search-input"
          [formControl]="fileResourceFilterCtrl"
          placeholder="Search..."
          autocomplete="off"
        />
        <mat-option *ngIf="!filteredFileResources?.length" disabled> No matches found </mat-option>
        <ng-container *ngFor="let fileResource of filteredFileResources; let c = count">
          <mat-option [value]="fileResource.id">{{ fileResource?.name }} </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="actions">
    <div class="formatting"></div>
    <div class="buttons">
      <button class="discard-button" mat-button type="button" (click)="discard()">
        <span>Close</span>
      </button>

      <button
        class="send-button mr-3"
        mat-flat-button
        [color]="'primary'"
        type="button"
        [disabled]="projectForm.invalid"
        (click)="sendToDocusign()"
        *ngIf="
          account &&
          (account.subdomain === 'msc' || account.subdomain === 'urbanedge' || account.subdomain === 'urbanedgepoc')
        "
      >
        <span *ngIf="!projectForm.disabled">Send to Docusign</span>
        <mat-progress-spinner
          *ngIf="projectForm.disabled"
          [diameter]="24"
          [mode]="'indeterminate'"
        ></mat-progress-spinner>
      </button>

      <button
        class="send-button"
        mat-flat-button
        [color]="'primary'"
        type="submit"
        [disabled]="projectForm.invalid"
        (click)="save()"
      >
        <span *ngIf="!projectForm.disabled">Download</span>
        <mat-progress-spinner
          *ngIf="projectForm.disabled"
          [diameter]="24"
          [mode]="'indeterminate'"
        ></mat-progress-spinner>
      </button>
    </div>
  </div>
</form>
